import { GetServerSideProps } from 'next';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ReceiveCompoment from '@/components/Ambassador/Receive';
import { ReferralProvider } from '@/components/Ambassador/ReferralProvider';
import { MonthlyProvider } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import SEOlinksA from '@/components/SEOlinksA';

const AmbassadorProgramReferred: React.FC<any> = ({ SEO, isLogin }) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');

    return (
        <>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA locale={locale} list={['eu', 'us', 'au']} pathname={'ambassador-program-referred'} />
            <PageLayout>
                <MonthlyProvider>
                    <ReferralProvider>
                        <ReceiveCompoment isLogin={isLogin} />
                    </ReferralProvider>
                </MonthlyProvider>
            </PageLayout>
        </>
    );
};

export default AmbassadorProgramReferred;

export const getServerSideProps: GetServerSideProps = async ({ locale, req }) => {
    const whiteLocaleList = ['eu', 'us', 'au'];
    if (!whiteLocaleList.includes(locale as string)) {
        return { notFound: true };
    }
    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            isLogin,
        },
    };
};
